"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isRef(obj) {
    if (obj !== null && typeof obj === 'object') {
        var keys = Object.keys(obj);
        return keys.length === 1 && keys[0] === 'current';
    }
    return false;
}
exports.isRef = isRef;
